import type { Survey } from '@engagement-web-app/common';
import { ChartArea } from 'lucide-react';
import { Button } from '@/components/Button';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { Pill } from '@/components/Pill';
import { Skeleton } from '@/components/Skeleton';
import { formatDateToLabel } from '@/utils';
import * as styles from '../index.css';

type SurveyCardProps = {
    survey: Survey;
    onOpen: () => void;
};

export function SurveyCard({ survey, onOpen }: SurveyCardProps) {
    return (
        <Flex align="center" gap="16" className={styles.surveyCard}>
            <Flex direction="column" gap="4" className={styles.surveyCardContent}>
                {formatDateToLabel(survey.surveyDate)}
                <Flex gap="4">
                    <Pill variant={survey.isPublished ? 'secondary' : 'tertiary'}>
                        {survey.isPublished ? '公開中' : '未公開'}
                    </Pill>
                </Flex>
            </Flex>

            {/* TODO: Ideally use anchor with href */}
            <Button variant="primary" onClick={onOpen}>
                <Icon icon={ChartArea} size="sm" />
                サーベイ分析画面を開く
            </Button>
        </Flex>
    );
}

export function SurveyCardSkeleton() {
    return (
        <Flex align="center" gap="16" className={styles.surveyCard}>
            <Flex direction="column" gap="4" className={styles.surveyCardContent}>
                <Skeleton.Line width={120} height="base" />
                <Skeleton.Box width={64} height={24} />
            </Flex>

            <Skeleton.Box width={168} height={36} />
        </Flex>
    );
}
